export const DEBUG = false
export const BACKEND_URL = `https://${window.location.hostname}`
export const GOOGLE_RECAPTCHA_SITE_KEY = '6LeVBcwdAAAAAFLT7dPaCnRoa4OeTx8Er17jp72E'

// Domain Specific Configs
const DOMAIN_CONFIGS = {
  'stormylikes.com': {
    // branding
    BRAND_NAME: 'StormyLikes',
    BRAND_DOMAIN: 'stormylikes.com',
    BRAND_BASE_URL: 'https://stormylikes.com',
    BRAND_SUPPORT_EMAIL: 'support@stormylikes.com',
    BRAND_LOGO_FOLDER: 'stormylikes',

    // authorize.net
    AUTHORIZE_NET_PUBLIC_KEY: '9uHwvettG9Us4Nf7Zv54Z9PdM3MC2ZX5jgKk2J6JPU9LtgW85Cutez66k2VDkrU2',
    AUTHORIZE_NET_LOGIN_ID: '7HqQm32K'
  },
  'liketank.com': {
    // branding
    BRAND_NAME: 'LikeTank',
    BRAND_DOMAIN: 'liketank.com',
    BRAND_BASE_URL: 'https://liketank.com',
    BRAND_SUPPORT_EMAIL: 'support@liketank.com',
    BRAND_LOGO_FOLDER: 'liketank',

    // authorize.net
    AUTHORIZE_NET_PUBLIC_KEY: '79rj65gm34n5u58s498p5d7EEPDG8bf8ZcDc22Kk6h4WK9VX8BbQhNd35BtuCtnT',
    AUTHORIZE_NET_LOGIN_ID: '4v9e6NGmFb'
  },
}
// ------------------ END OF CONFIGURATION ------------------


// ************************************************************************************
// *************************** DO NOT EDIT BELLOW THIS LINE ***************************
// ************************************************************************************
// Normalize domain by removing www prefix and converting to lowercase
const normalizeDomain = (domain) => {
  if (!domain) return domain
  domain = domain.toLowerCase()
  if (domain.startsWith('www.')) {
    domain = domain.substring(4)
  }
  return domain
}

const hostname = window.location.hostname
const port = window.location.port
const domainWithPort = port ? `${hostname}:${port}` : hostname

// Try to find configuration with normalized domains (handles both www and non-www)
const normalizedDomainWithPort = normalizeDomain(domainWithPort)
const normalizedHostname = normalizeDomain(hostname)

let currentDomainConfig = DOMAIN_CONFIGS[domainWithPort] ||
                         DOMAIN_CONFIGS[hostname] ||
                         DOMAIN_CONFIGS[normalizedDomainWithPort] ||
                         DOMAIN_CONFIGS[normalizedHostname]
if (!currentDomainConfig) {
  throw new Error(
    `No configuration found for domain: ${domainWithPort}.
    Please add configuration for this domain in DOMAIN_CONFIGS.`
  )
}
export const AUTHORIZE_NET_PUBLIC_KEY = currentDomainConfig.AUTHORIZE_NET_PUBLIC_KEY
export const AUTHORIZE_NET_LOGIN_ID = currentDomainConfig.AUTHORIZE_NET_LOGIN_ID
export const BRAND_NAME = currentDomainConfig.BRAND_NAME
export const BRAND_DOMAIN = currentDomainConfig.BRAND_DOMAIN
export const BRAND_BASE_URL = currentDomainConfig.BRAND_BASE_URL
export const BRAND_SUPPORT_EMAIL = currentDomainConfig.BRAND_SUPPORT_EMAIL
export const BRAND_LOGO_FOLDER = currentDomainConfig.BRAND_LOGO_FOLDER
